<template>
  <v-card color="basil">
    <v-toolbar :color="background" flat height="120">
      <v-img :src="getLogo()" contain height="100px"></v-img>
    </v-toolbar>

    <v-tabs
      v-model="tab"
      background-color="transparent"
      grow
      @change="handleTabChange"
    >
      <v-tab v-for="item in items" :key="item.name">
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="item.name">
        <component :is="item.component" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import RootLayout from "@/components/layouts/RootLayout.vue";
import DetailByInmo from "@/components/root/DetailByInmo.vue";
import DevelopmentsByInmo from "../../components/root/DevelopmentsByInmo.vue";
import UsersByInmo from "../../components/root/UsersByInmo.vue";
import CarouselsByInmo from "../../components/root/CarouselsByInmo.vue";
import LeadsByInmoVue from "../../components/root/LeadsByInmo.vue";
export default {
  name: "RealEstateGroupDetail",
  components: {
    DevelopmentsByInmo,
    UsersByInmo,
    CarouselsByInmo,
    DetailByInmo,
    LeadsByInmoVue
  },
  data() {
    return {
      background: "blue-grey lighten-4",
      tab: null,
      items: [
        {
          name: "General/Config",
          component: "DetailByInmo",
          route: "general"
        },
        {
          name: "Developments",
          component: "DevelopmentsByInmo",
          route: "developments"
        },
        {
          name: "Users",
          component: "UsersByInmo",
          route: "users"
        },
        {
          name: "Carruseles",
          component: "CarouselsByInmo",
          route: "carruseles"
        },
        {
          name: "Leads",
          component: "LeadsByInmoVue",
          route: "leads"
        }
      ]
    };
  },
  created() {
    this.$emit(`update:layout`, RootLayout);
  },
  mounted() {
    const id = this.$route.params.id;
    this.fetchInmoInspect(id);
    this.initializeTabFromRoute();
  },
  computed: {
    ...mapGetters("root", {
      inmo: "getInmoInspect"
    })
  },
  watch: {
    "$route.params.tab": {
      handler(newTab) {
        const tabIndex = this.items.findIndex(item => item.route === newTab);
        if (tabIndex !== -1 && tabIndex !== this.tab) {
          this.tab = tabIndex;
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations("root", {
      setInmoInspect: "setInmoInspect"
    }),
    ...mapActions("root", {
      fetchInmoInspect: "fetchInmoInspect"
    }),
    getLogo() {
      if (this.inmo.media?.logo?.src) {
        return this.inmo.media.logo.src;
      }
      return require("@/assets/logoC28_primary.png");
    },
    handleTabChange(index) {
      const selectedItem = this.items[index];
      this.$router.push({
        name: this.$route.name,
        params: {
          id: this.$route.params.id,
          tab: selectedItem.route
        }
      });
    },
    initializeTabFromRoute() {
      const currentTab = this.$route.params.tab;
      const tabIndex = this.items.findIndex(item => item.route === currentTab);
      if (tabIndex !== -1) {
        this.tab = tabIndex;
      } else {
        // Si no hay tab en la URL, redirigir al primer tab
        this.$router.replace({
          name: this.$route.name,
          params: {
            id: this.$route.params.id,
            tab: this.items[0].route
          }
        });
      }
    }
  },
  beforeDestroy() {
    this.setInmoInspect({});
  }
};
</script>
